export class ProjectInput {
    public name: string = '';
}
